import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SubscriptionsPage } from "@/features/subscriptions/SubscriptionsPage";

const search = z.object({
  peek: z.string().optional(),
  status: z.enum(["all", "active", "trial", "paused", "past-due", "cancelled", "ended"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/subscriptions/")({
  validateSearch: search,
  component: () => <SubscriptionsPage search={Route.useSearch()} />,
});
